/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Across_DirectoryInputs */

const en_directory_launch_across_directory = /** @type {(inputs: Directory_Launch_Across_DirectoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Across the directory`)
};

const zh_directory_launch_across_directory = /** @type {(inputs: Directory_Launch_Across_DirectoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`覆盖目录范围`)
};

/**
* | output |
* | --- |
* | "Across the directory" |
*
* @param {Directory_Launch_Across_DirectoryInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_across_directory = /** @type {((inputs?: Directory_Launch_Across_DirectoryInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Across_DirectoryInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_across_directory(inputs)
	return zh_directory_launch_across_directory(inputs)
});
export { directory_launch_across_directory as "directory.launch.across_directory" }